import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { Translate as T } from 'react-redux-i18n';

type FooterButtonProps = {
  kind: 'tertiary' | 'primary';
  type: 'button' | 'submit';
  onClickFunction?: () => void;
  value: 'buttons.continue' | 'buttons.back' | 'buttons.send';
  testId: string;
  disabled: boolean;
  processing: boolean;
};

const FooterButton = ({
  kind,
  type,
  onClickFunction = () => {},
  value,
  testId,
  disabled = false,
  processing,
}: FooterButtonProps) => (
  <M.Button
    kind={kind}
    data-testid={testId}
    type={type}
    onClick={onClickFunction}
    disabled={disabled}
  >
    {value === 'buttons.back' && <>&lt; </>}
    {processing && type === 'submit' && (
      <M.LoadingInline className='button-loading-icon' />
    )}
    {!processing && <T value={value} />}
  </M.Button>
);

export default FooterButton;
